import { ArrowDownAZ, CalendarClock } from 'lucide-react'
import { copy } from '@/lib/copy'
import { cn } from '@/components/ui/cn'
import type { VocabularySortMode } from '@/lib/vocabularySortStorage'

interface VocabularySortToggleProps {
  value: VocabularySortMode
  onChange: (mode: VocabularySortMode) => void
  className?: string
  testId?: string
}

export function VocabularySortToggle({ value, onChange, className, testId }: VocabularySortToggleProps) {
  return (
    <div
      className={cn('flex rounded-md border bg-background p-0.5', className)}
      data-testid={testId}
    >
      <button
        type="button"
        aria-label={copy.vocabulary.sortAlphabeticalAria}
        title={copy.vocabulary.sortAlphabeticalAria}
        onClick={() => onChange('alphabetical')}
        className={cn(
          'flex items-center gap-1.5 rounded px-2.5 py-1.5 text-xs font-medium transition-colors',
          value === 'alphabetical'
            ? 'bg-accent text-foreground'
            : 'text-muted-foreground hover:text-foreground',
        )}
        data-testid="vocabulary-sort-alphabetical"
      >
        <ArrowDownAZ className="h-4 w-4" />
        <span className="hidden sm:inline">{copy.vocabulary.sortAlphabetical}</span>
      </button>
      <button
        type="button"
        aria-label={copy.vocabulary.sortDateAddedAria}
        title={copy.vocabulary.sortDateAddedAria}
        onClick={() => onChange('dateAdded')}
        className={cn(
          'flex items-center gap-1.5 rounded px-2.5 py-1.5 text-xs font-medium transition-colors',
          value === 'dateAdded'
            ? 'bg-accent text-foreground'
            : 'text-muted-foreground hover:text-foreground',
        )}
        data-testid="vocabulary-sort-date-added"
      >
        <CalendarClock className="h-4 w-4" />
        <span className="hidden sm:inline">{copy.vocabulary.sortDateAdded}</span>
      </button>
    </div>
  )
}
